import styled from "styled-components";
import { theme } from "../theme/lexusTheme";
import { IconWrapper } from "../globals/IconWrapper";

export const Button = styled.button`
    display: inline-block;
    align-self: stretch;
    padding: ${theme.space[2]}px ${theme.space[3]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    letter-spacing: 0.1em;
    line-height: 2.4rem;
    text-transform: uppercase;
    color: ${theme.colors.white};
    white-space: nowrap;
    background-color: ${theme.colors.azure};
    border: 0;
    .icon::before {
        position: relative;
        font-size: 1.6rem;
        color: ${theme.colors.white};
    }

    ${IconWrapper} {
        margin-left: ${theme.space[2]}px;

        /* Fix vertical alignment in iconwrapper */
        .icon {
            position: relative;
            top: -2px;
        }
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            margin-left: 0;
            margin-right: ${theme.space[2]}px;
        }
    }
`;

export const IconBadge = styled.span`
    position: relative;
    top: -3px;
    margin-left: ${theme.space[2]}px;

    span {
        display: inline-block;
        width: 18px;
        height: 18px;
        padding-left: 1px;
        font-size: 1.1rem;
        line-height: 1.8rem;
        text-align: center;
        color: ${theme.colors.azure};
        background-color: ${theme.colors.white};
        border-radius: 100%;
        vertical-align: middle;
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[2]}px;

        span {
            padding-left: 0;
            padding-right: 1px;
        }
    }
`;

export const MobileBasket = styled.div`
    display: flex;
    position: fixed;
    inset: 0;
    flex: 1 1 auto;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    margin-top: -1px;
    padding: ${theme.space[2]}px;
    background: ${theme.colors.midnight};
    border-top: 1px solid ${theme.colors.midnight};
    z-index: ${theme.zIndex.mobileBasket};
`;

export const BasketTitle = styled.h2`
    margin: 0;
    padding: 0 0 ${theme.space[2]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    line-height: 2rem;
    text-align: start;
    color: ${theme.colors.white};
`;

export const BasketTitleWrapper = styled.div`
    padding-top: ${theme.space[3]}px;
    background-color: ${theme.colors.white};
`;
